import { useState } from "react";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { default_post_id } from "../../../../../utils";
import { useFindContent } from "../../useFindContent";
import { ContentProps } from "../Content";
import { MaxWidthContainer } from "../style";
import CreateSlider from "./CreateSlider";
import SliderPreview from "./SliderPreview";

const Slider = ({ id }: ContentProps.CommonProps) => {
  const { content_data } = useFindContent(id) as ArticleProps.WithRatingContent;
  const { question, left_emoji_id, right_emoji_id } = content_data;
  const is_left_emoji_id_valid = left_emoji_id !== default_post_id;
  const is_right_emoji_id_valid = right_emoji_id !== default_post_id;
  const [isSliderCreated, setIsSliderCreated] = useState(
    question.length > 0 && is_left_emoji_id_valid && is_right_emoji_id_valid
  );

  return (
    <MaxWidthContainer>
      {isSliderCreated ? (
        <SliderPreview setIsSliderCreated={setIsSliderCreated} id={id} />
      ) : (
        <CreateSlider setIsSliderCreated={setIsSliderCreated} id={id} />
      )}
    </MaxWidthContainer>
  );
};

export default Slider;
